module.exports = __webpack_public_path__ + "img/payangel-logo.12707824.svg";